(function () {
  var SELECTOR = '[data-th-headline-autoscale]';
  var DESKTOP_MQ = window.matchMedia('(min-width: 990px)');

  function lineCount(el) {
    var range = document.createRange();
    range.selectNodeContents(el);
    var rects = range.getClientRects();
    var tops = Object.create(null);

    for (var i = 0; i < rects.length; i++) {
      var rect = rects[i];
      if (rect.width <= 0 || rect.height <= 0) continue;
      tops[Math.round(rect.top)] = true;
    }

    return Object.keys(tops).length;
  }

  function fitHeadline(headline) {
    var maxSize;
    var minSize;

    if (DESKTOP_MQ.matches) {
      maxSize = parseInt(headline.dataset.maxSize, 10) || 52;
      minSize = parseInt(headline.dataset.minSize, 10) || 32;
    } else {
      maxSize = parseInt(headline.dataset.maxSizeMobile, 10) || 40;
      minSize = parseInt(headline.dataset.minSizeMobile, 10) || 24;
    }

    var low = minSize;
    var high = maxSize;
    var best = minSize;

    while (low <= high) {
      var mid = Math.floor((low + high) / 2);
      headline.style.fontSize = mid + 'px';

      if (lineCount(headline) <= 2) {
        best = mid;
        low = mid + 1;
      } else {
        high = mid - 1;
      }
    }

    headline.style.fontSize = best + 'px';
  }

  function initHeadline(headline) {
    if (!headline || headline.__thHeadlineFitInit) return;
    headline.__thHeadlineFitInit = true;

    var run = function () {
      requestAnimationFrame(function () {
        fitHeadline(headline);
      });
    };

    run();

    if (typeof ResizeObserver !== 'undefined') {
      var target =
        headline.closest('.th-built-diff__copy--split') ||
        headline.closest('.th-sci-hero__title') ||
        headline;
      var ro = new ResizeObserver(run);
      ro.observe(target);
      headline.__thHeadlineFitObserver = ro;
    }

    if (DESKTOP_MQ.addEventListener) {
      DESKTOP_MQ.addEventListener('change', run);
    } else if (DESKTOP_MQ.addListener) {
      DESKTOP_MQ.addListener(run);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(run);
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(initHeadline);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
